import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

export const useEventUuidParam = () => {
	const id = useParams<{ id: string }>().id;
	return useMemo(() => id, [id]);
};

export const useEventUuidParamModerator = () => {
	const params = useParams<{ event_uuid: string }>();
	return useMemo(() => params?.event_uuid, [params?.event_uuid]);
};